import { fetchApi } from '../lib/apiClient';
import {AssemblyParameters} from '@uppy/transloadit';

/**
 * Transloadit 参数响应接口
 */
export interface TransloaditParams {
  success: boolean;
  params: AssemblyParameters;
  signature: string;
}

/**
 * 媒体服务类
 * 处理与媒体相关的 API 请求
 */
export const mediaService = {
  /**
   * 获取 Transloadit 参数和签名
   * @returns {Promise<TransloaditParams>} - Transloadit 参数和签名
   */
  async getTransloaditParams(): Promise<TransloaditParams> {
    try {
      const data = await fetchApi<TransloaditParams>('/media/transloadit-params', {
        method: 'POST',
      });

      if (!data || !data.success || !data.params || !data.params.auth || 
          !data.params.auth.key || !data.params.auth.expires || !data.signature) {
        throw new Error('Invalid response from server when getting Transloadit parameters');
      }

      return data;
    } catch (error) {
      console.error('获取 Transloadit 参数失败:', error);
      throw error;
    }
  }
};

export default mediaService;
